// Albanian is the default. English mirrors it for the toggle.
// Add keys here; nothing else in the app hardcodes user-facing copy.
const translations = {
  sq: {
    nav: { how: "Si funksionon", forBusiness: "Për bizneset", saved: "Të ruajtura" },
    hero: {
      title: "Gjithçka për dasmën tuaj,",
      titleEm: "në një vend.",
      subtitle:
        "Salla, fotografë, dekorime, muzikë e shumë më tepër — gjeni dhe kontaktoni drejtpërdrejt biznesin që ju pëlqen.",
      cta: "Filloni kërkimin",
    },
    stats: { businesses: "Biznese", cities: "Qytete", categories: "Kategori" },
    filter: {
      all: "Të gjitha",
      cityAll: "Qyteti — të gjitha",
      priceAll: "Çmimi — të gjitha",
      priceEco: "€ Ekonomik",
      priceMid: "€€ Mesatar",
      pricePremium: "€€€ Premium",
      typeAll: "Kompani & individë",
      typeCompany: "Vetëm kompani",
      typeIndividual: "Vetëm individë",
    },
    section: { title: "Biznese për dasmën", results: "rezultate" },
    card: { call: "Telefono", whatsapp: "WhatsApp", company: "Kompani", individual: "Individ", featured: "I rekomanduar" },
    footer: {
      title: "Keni një biznes për dasma?",
      subtitle:
        "Shfaqeni para mijëra çifteve që po planifikojnë dasmën e tyre. Regjistrohuni, dërgoni fotot tuaja, dhe ne ju aktivizojmë.",
      cta: "Regjistro biznesin tënd",
      note: "© Amora Weddings",
      manage: "Tashmë i regjistruar? Menaxho biznesin",
      about: "Rreth nesh",
      faq: "Pyetjet e shpeshta",
      contact: "Kontakt",
      terms: "Kushtet",
      privacy: "Privatësia",
      rights: "Të gjitha të drejtat e rezervuara.",
      tagline: "Çdo gjë për dasmën tënde, në një vend.",
    },
    auth: {
      forgot: "Keni harruar fjalëkalimin?",
      resetSent: "Të dërguam një email për ndryshimin e fjalëkalimit.",
      resetError: "Nuk u dërgua. Kontrollo email-in.",
      enterEmail: "Shkruaj email-in tënd më parë.",
    },
    list: {
      title: "Regjistro biznesin tënd",
      subtitle: "Plotësoni të dhënat, dërgoni fotot, dhe ne ju kontaktojmë për aktivizim.",
      businessName: "Emri i biznesit",
      category: "Kategoria",
      choose: "Zgjidh...",
      accountType: "Lloji",
      company: "Kompani",
      individual: "Individ",
      city: "Qyteti",
      price: "Çmimi",
      phone: "Telefoni",
      phoneHint: "p.sh. +38344123456",
      whatsapp: "WhatsApp",
      whatsappHint: "Numri pa +, p.sh. 38344123456",
      instagram: "Instagram",
      instagramHint: "Pa @, p.sh. emri_biznesit",
      description: "Përshkrimi",
      photos: "Fotot",
      photosHint: "(deri në 6)",
      addPhoto: "Shto foto",
      uploading: "Duke ngarkuar...",
      uploadError: "Diçka shkoi keq. Provoni përsëri.",
      submit: "Dërgo regjistrimin",
      submitting: "Duke dërguar...",
      successTitle: "Faleminderit!",
      successText: "Regjistrimi u dërgua. Do t'ju kontaktojmë së shpejti për aktivizim.",
      backHome: "Kthehu në faqen kryesore",
      required: "Ju lutemi plotësoni fushat e detyrueshme (*).",
      step: "Hapi",
      of: "nga",
      next: "Vazhdo",
      back: "Mbrapa",
      sameWhatsapp: "Përdor të njëjtin numër për WhatsApp",
      step1Title: "Biznesi",
      step2Title: "Kontakti",
      step3Title: "Detajet",
      step4Title: "Plani",
      account: "Llogaria",
      accountHint: "Krijo një llogari për të menaxhuar listën tënde më vonë.",
      email: "Email",
      password: "Fjalëkalimi",
      weakPassword: "Fjalëkalimi duhet të ketë të paktën 6 karaktere.",
      invalidEmail: "Email i pavlefshëm.",
      emailInUse: "Ky email ekziston, por fjalëkalimi nuk përputhet.",
      goManage: "Menaxho biznesin tënd",
    },
    admin: {
      title: "Paneli i administrimit",
      loginTitle: "Hyrje në admin",
      email: "Email",
      password: "Fjalëkalimi",
      login: "Hyr",
      loginError: "Email ose fjalëkalim i gabuar.",
      logout: "Dil",
      pending: "Në pritje",
      active: "Aktive",
      all: "Të gjitha",
      noVendors: "Asnjë biznes.",
      activate: "Aktivizo",
      deactivate: "Çaktivizo",
      delete: "Fshij",
      confirmDelete: "Të fshihet ky biznes?",
      statusPending: "Në pritje",
      statusActive: "Aktiv",
      statusExpired: "Skaduar",
      duration: "Kohëzgjatja",
      months: "muaj",
      amount: "Shuma (€)",
      paid: "Paguar",
      starts: "Filloi",
      ends: "Përfundon",
      daysLeft: "ditë të mbetura",
      renew: "Rinovo",
      notAuthorized: "Kjo zonë është vetëm për administratorë.",
      boost: "Promovo",
      unboost: "Hiq promovimin",
      featured: "I promovuar",
      boosts: "Promovime",
      plans: "Planet",
      free: "FALAS",
      activate: "Aktivizo",
      freeBoostDays: "Ditë falas/muaj (Premium)",
      spotsFilled: "vende të zëna",
      pricing: "Çmimet",
      pricePerDay: "Çmimi për ditë (€)",
      maxSlots: "Vendet maksimale",
      bundles: "Oferta",
      addBundle: "Shto ofertë",
      save: "Ruaj",
      boostRequests: "Kërkesat për promovim",
      noRequests: "Asnjë kërkesë.",
      approve: "Aprovo",
      decline: "Refuzo",
      confirmPaid: "Konfirmo pagesën",
      removeBoost: "Hiq promovimin",
      bs_requested: "Në pritje",
      bs_approved: "Aprovuar",
      bs_active: "Aktiv",
      bs_declined: "Refuzuar",
      bs_expired: "Skaduar",
    },
    profile: {
      back: "Kthehu",
      about: "Rreth biznesit",
      save: "Ruaj",
      saved: "E ruajtur",
      notFound: "Biznesi nuk u gjet.",
      website: "Ueb-faqe",
      video: "Video",
      watchVideo: "Shiko videon",
    },
    saved: {
      title: "Të ruajtura",
      empty: "Nuk keni ruajtur asnjë biznes ende.",
      browse: "Shfleto bizneset",
    },
    manage: {
      loginTitle: "Menaxho biznesin tënd",
      loginSub: "Hyni me llogarinë e biznesit tuaj.",
      login: "Hyr",
      loginError: "Email ose fjalëkalim i gabuar.",
      noAccount: "Nuk keni biznes të regjistruar?",
      register: "Regjistro biznesin",
      premiumExtras: "Përfitimet Premium",
      upsell: "Kalo në Premium për të shtuar video, ueb-faqe, më shumë foto dhe kategori shtesë.",
      title: "Biznesi yt",
      statusLabel: "Statusi",
      save: "Ruaj ndryshimet",
      saving: "Duke ruajtur...",
      saved: "Ndryshimet u ruajtën!",
      logout: "Dil",
      none: "Nuk u gjet asnjë biznes për këtë llogari.",
    },
    boost: {
      title: "Promovo biznesin",
      subtitle: "Ngjit biznesin tënd në krye të listës.",
      views: "shikime",
      contacts: "kontakte",
      active: "I promovuar",
      awaiting: "Kërkesa juaj është në pritje të aprovimit.",
      approvedPre: "U aprovua! Paguani",
      approvedPost: "për ta aktivizuar. Do ta aktivizojmë sapo të konfirmohet pagesa.",
      spotsTaken: "vende të zëna",
      left: "të lira",
      days: "ditë",
      customDays: "Ose zgjidh ditët:",
      fullNote: "Të gjitha vendet janë të zëna tani — mund të dërgoni kërkesë dhe e aktivizojmë sapo lirohet një vend.",
      request: "Dërgo kërkesën",
      sending: "Duke dërguar...",
      freeDays: "ditë promovimi falas këtë muaj",
      freeNote: "Si biznes Premium, merr ditë promovimi falas çdo muaj.",
      useFree: "Përdor ditët falas",
    },
    how: {
      title: "Si funksionon",
      subtitle: "Gjeni gjithçka për dasmën tuaj, ose shfaqni biznesin tuaj para mijëra çifteve.",
      couples: "Për çiftet",
      businesses: "Për bizneset",
      c1t: "Kërko",
      c1d: "Filtro sipas kategorisë, qytetit dhe çmimit për të gjetur atë që të duhet.",
      c2t: "Ruaj",
      c2d: "Ruaj bizneset që të pëlqejnë në listën tënde — pa llogari.",
      c3t: "Kontakto",
      c3d: "Telefono, shkruaj në WhatsApp ose Instagram direkt me biznesin.",
      b1t: "Regjistrohu",
      b1d: "Krijo listën e biznesit tënd dhe ngarko fotot në pak minuta.",
      b2t: "Aktivizohu",
      b2d: "Ne e shqyrtojmë, ti paguan, dhe biznesi yt shfaqet në platformë.",
      b3t: "Menaxho & Promovo",
      b3d: "Përditëso listën kurdoherë dhe promovoje në krye për më shumë shikime.",
      cta: "Regjistro biznesin",
      ctaCouples: "Fillo kërkimin",
    },
    meta: {
      home: "Amora Weddings — Çdo gjë për dasmën tënde, në një vend",
      homeDesc: "Gjeni salla, fotografë, dekorime, muzikë e më shumë për dasmën tuaj.",
      how: "Si funksionon — Amora Weddings",
      list: "Regjistro biznesin — Amora Weddings",
      saved: "Të ruajtura — Amora Weddings",
    },
    plan: {
      intro: "Zgjidh planin për biznesin tënd.",
      basic: "Bazik",
      premium: "Premium",
      mo: "muaj",
      popular: "Më i zgjedhuri",
      select: "Zgjidh",
      selected: "I zgjedhur",
      b1: "5 foto",
      b2: "Telefon + WhatsApp",
      b3: "Pozicion standard në listë",
      p1: "20 foto",
      p2: "Video, ueb-faqe & Instagram",
      p3: "Pozicion mbi bizneset bazike",
      p4: "3 ditë promovim falas çdo muaj",
      p5: "Shih shikimet & kontaktet",
      p6: "Deri në 3 kategori",
      extrasTitle: "Përfitimet Premium",
      video: "Video (link)",
      videoHint: "YouTube ose Instagram",
      website: "Ueb-faqe",
      extraCats: "Kategori shtesë",
      extraCatsHint: "zgjidh deri në 2",
      foundingNote: "Çmim themelues — vetëm për 10 bizneset e para.",
    },
    plans: {
      others: "Të tjerat",
      founding: "biznese themeluese",
      foundingPrices: "Çmimet themeluese",
      standard: "Çmimet standarde (pas 10)",
      activeFounding: "Aktive: çmimet themeluese",
      activeStandard: "Aktive: çmimet standarde",
      pricing: "Çmimet e planeve",
      limit: "Kufiri themelues",
      hint: "Këto çmime shihen nga bizneset kur regjistrohen. Pas mbushjes së vendeve themeluese, ndrysho çmimet këtu.",
    },
    price: {
      label: "Çmimi (opsionale)",
      tier: "€ €€ €€€",
      range: "Interval",
      from: "Duke filluar nga",
      none: "Pa çmim",
      min: "Nga",
      max: "Deri",
      amount: "Shuma",
      hint: "Zgjidh si shfaqet çmimi — ose mos e shfaq fare.",
    },
    empty: "Asnjë biznes nuk u gjet për këtë filtër.",
  },
  en: {
    nav: { how: "How it works", forBusiness: "For businesses", saved: "Saved" },
    hero: {
      title: "Everything for your wedding,",
      titleEm: "in one place.",
      subtitle:
        "Venues, photographers, decoration, music and much more — find and contact the business you love, directly.",
      cta: "Start searching",
    },
    stats: { businesses: "Businesses", cities: "Cities", categories: "Categories" },
    filter: {
      all: "All",
      cityAll: "City — all",
      priceAll: "Price — all",
      priceEco: "€ Budget",
      priceMid: "€€ Mid",
      pricePremium: "€€€ Premium",
      typeAll: "Companies & individuals",
      typeCompany: "Companies only",
      typeIndividual: "Individuals only",
    },
    section: { title: "Wedding businesses", results: "results" },
    card: { call: "Call", whatsapp: "WhatsApp", company: "Company", individual: "Individual", featured: "Featured" },
    footer: {
      title: "Have a wedding business?",
      subtitle:
        "Get in front of thousands of couples planning their wedding. Register, send your photos, and we activate you.",
      cta: "List your business",
      note: "© Amora Weddings",
      manage: "Already registered? Manage your business",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      terms: "Terms",
      privacy: "Privacy",
      rights: "All rights reserved.",
      tagline: "Everything for your wedding, in one place.",
    },
    auth: {
      forgot: "Forgot your password?",
      resetSent: "We've sent you a password reset email.",
      resetError: "Couldn't send. Check the email address.",
      enterEmail: "Enter your email first.",
    },
    list: {
      title: "List your business",
      subtitle: "Fill in your details, send your photos, and we'll contact you to activate.",
      businessName: "Business name",
      category: "Category",
      choose: "Choose...",
      accountType: "Type",
      company: "Company",
      individual: "Individual",
      city: "City",
      price: "Price",
      phone: "Phone",
      phoneHint: "e.g. +38344123456",
      whatsapp: "WhatsApp",
      whatsappHint: "Number without +, e.g. 38344123456",
      instagram: "Instagram",
      instagramHint: "Without @, e.g. business_name",
      description: "Description",
      photos: "Photos",
      photosHint: "(up to 6)",
      addPhoto: "Add photo",
      uploading: "Uploading...",
      uploadError: "Something went wrong. Please try again.",
      submit: "Send registration",
      submitting: "Sending...",
      successTitle: "Thank you!",
      successText: "Your registration was sent. We'll contact you shortly to activate.",
      backHome: "Back to home",
      required: "Please fill in the required fields (*).",
      step: "Step",
      of: "of",
      next: "Next",
      back: "Back",
      sameWhatsapp: "Use the same number for WhatsApp",
      step1Title: "Business",
      step2Title: "Contact",
      step3Title: "Details",
      step4Title: "Plan",
      account: "Account",
      accountHint: "Create an account so you can manage your listing later.",
      email: "Email",
      password: "Password",
      weakPassword: "Password must be at least 6 characters.",
      invalidEmail: "Invalid email.",
      emailInUse: "This email exists, but the password doesn't match.",
      goManage: "Manage your business",
    },
    admin: {
      title: "Admin panel",
      loginTitle: "Admin login",
      email: "Email",
      password: "Password",
      login: "Log in",
      loginError: "Wrong email or password.",
      logout: "Log out",
      pending: "Pending",
      active: "Active",
      all: "All",
      noVendors: "No businesses.",
      activate: "Activate",
      deactivate: "Deactivate",
      delete: "Delete",
      confirmDelete: "Delete this business?",
      statusPending: "Pending",
      statusActive: "Active",
      statusExpired: "Expired",
      duration: "Duration",
      months: "mo.",
      amount: "Amount (€)",
      paid: "Paid",
      starts: "Started",
      ends: "Ends",
      daysLeft: "days left",
      renew: "Renew",
      notAuthorized: "This area is for admins only.",
      boost: "Boost",
      unboost: "Remove boost",
      featured: "Featured",
      boosts: "Boosts",
      plans: "Plans",
      free: "FREE",
      activate: "Activate",
      freeBoostDays: "Free days/mo (Premium)",
      spotsFilled: "spots filled",
      pricing: "Pricing",
      pricePerDay: "Price per day (€)",
      maxSlots: "Max spots",
      bundles: "Bundles",
      addBundle: "Add bundle",
      save: "Save",
      boostRequests: "Boost requests",
      noRequests: "No requests.",
      approve: "Approve",
      decline: "Decline",
      confirmPaid: "Confirm payment",
      removeBoost: "Remove boost",
      bs_requested: "Pending",
      bs_approved: "Approved",
      bs_active: "Active",
      bs_declined: "Declined",
      bs_expired: "Expired",
    },
    profile: {
      back: "Back",
      about: "About",
      save: "Save",
      saved: "Saved",
      notFound: "Business not found.",
      website: "Website",
      video: "Video",
      watchVideo: "Watch video",
    },
    saved: {
      title: "Saved",
      empty: "You haven't saved any businesses yet.",
      browse: "Browse businesses",
    },
    manage: {
      loginTitle: "Manage your business",
      loginSub: "Sign in with your business account.",
      login: "Log in",
      loginError: "Wrong email or password.",
      noAccount: "No business registered yet?",
      register: "List your business",
      premiumExtras: "Premium perks",
      upsell: "Upgrade to Premium to add a video, website, more photos and extra categories.",
      title: "Your business",
      statusLabel: "Status",
      save: "Save changes",
      saving: "Saving...",
      saved: "Changes saved!",
      logout: "Log out",
      none: "No business found for this account.",
    },
    boost: {
      title: "Boost your business",
      subtitle: "Push your listing to the top of the list.",
      views: "views",
      contacts: "contacts",
      active: "Boosted",
      awaiting: "Your request is awaiting approval.",
      approvedPre: "Approved! Pay",
      approvedPost: "to activate. We'll turn it on once payment is confirmed.",
      spotsTaken: "spots taken",
      left: "left",
      days: "days",
      customDays: "Or pick days:",
      fullNote: "All spots are taken right now — you can still request and we'll activate when one frees up.",
      request: "Send request",
      sending: "Sending...",
      freeDays: "free boost days this month",
      freeNote: "As a Premium business, you get free boost days every month.",
      useFree: "Use free days",
    },
    how: {
      title: "How it works",
      subtitle: "Find everything for your wedding, or put your business in front of thousands of couples.",
      couples: "For couples",
      businesses: "For businesses",
      c1t: "Browse",
      c1d: "Filter by category, city and price to find exactly what you need.",
      c2t: "Save",
      c2d: "Save the businesses you like to your list — no account needed.",
      c3t: "Contact",
      c3d: "Call, WhatsApp or message the business directly.",
      b1t: "Register",
      b1d: "Create your business listing and upload your photos in minutes.",
      b2t: "Get activated",
      b2d: "We review it, you pay, and your business goes live on the platform.",
      b3t: "Manage & boost",
      b3d: "Update your listing anytime and boost it to the top for more views.",
      cta: "List your business",
      ctaCouples: "Start searching",
    },
    meta: {
      home: "Amora Weddings — Everything for your wedding, in one place",
      homeDesc: "Find venues, photographers, decoration, music and more for your wedding.",
      how: "How it works — Amora Weddings",
      list: "List your business — Amora Weddings",
      saved: "Saved — Amora Weddings",
    },
    plan: {
      intro: "Choose a plan for your business.",
      basic: "Basic",
      premium: "Premium",
      mo: "mo",
      popular: "Most popular",
      select: "Select",
      selected: "Selected",
      b1: "5 photos",
      b2: "Phone + WhatsApp",
      b3: "Standard placement",
      p1: "20 photos",
      p2: "Video, website & Instagram",
      p3: "Ranks above Basic listings",
      p4: "3 free boost days every month",
      p5: "See your views & contacts",
      p6: "Up to 3 categories",
      extrasTitle: "Premium perks",
      video: "Video (link)",
      videoHint: "YouTube or Instagram",
      website: "Website",
      extraCats: "Extra categories",
      extraCatsHint: "pick up to 2",
      foundingNote: "Founding price — first 10 businesses only.",
    },
    plans: {
      others: "Everything else",
      founding: "founding businesses",
      foundingPrices: "Founding prices",
      standard: "Standard prices (after 10)",
      activeFounding: "Active: founding prices",
      activeStandard: "Active: standard prices",
      pricing: "Plan pricing",
      limit: "Founding limit",
      hint: "These prices are shown to businesses when they register. After the founding spots fill, change the prices here.",
    },
    price: {
      label: "Price (optional)",
      tier: "€ €€ €€€",
      range: "Range",
      from: "Starting from",
      none: "No price",
      min: "From",
      max: "To",
      amount: "Amount",
      hint: "Choose how your price shows — or hide it entirely.",
    },
    empty: "No businesses found for this filter.",
  },
};

export default translations;
